import { render, staticRenderFns } from "./SwitchTransferGateway.vue?vue&type=template&id=1d7fc154&"
import script from "./SwitchTransferGateway.vue?vue&type=script&lang=js&"
export * from "./SwitchTransferGateway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports